import { Button } from 'core-components/library/button'
import { Input } from 'core-components/library/inputs'
import { TPopupHorizontal } from 'core-components/library/popup'
import { Tooltip } from 'core-components/library/tooltip'
import { IVisibilityWidgetSettings } from 'core-components/sitebuilder/models/flexGrid/ISystemWidgetSettings'

import styles from './SettingsCommonStyles.module.scss'

interface IVisibilitySettings {
  settings: IVisibilityWidgetSettings
  onChange: (data: Partial<IVisibilityWidgetSettings>) => void
}

export const VisibilitySettings = ({ settings, onChange }: IVisibilitySettings) => {
  return (
    <>
      <div className={styles.header}>Visibility:</div>
      <div className={styles.line}>
        <Input
          classes={{ root: styles.inputWidth }}
          label="Show this instance when URL contains"
          value={settings.showWhen}
          onChange={(value) => {
            onChange({
              showWhen: value,
            })
          }}
        />
        <Input
          classes={{ root: styles.inputWidth }}
          label="Show parameter value"
          value={settings.showWhenValue}
          onChange={(value) => {
            onChange({
              showWhenValue: value,
            })
          }}
        />
        <Tooltip
          horizontalStartPosition={TPopupHorizontal.Right}
          horizontalDirection={TPopupHorizontal.Left}
          tipContent={() => (
            <div>
              You can set a specific value or set any parameter values if you leave this field empty
            </div>
          )}
        >
          <Button variant={'text'} iconButton={'kbase kbase-info'} />
        </Tooltip>
      </div>

      <div className={styles.line}>
        <Input
          classes={{ root: styles.inputWidth }}
          label="Hide this instance when URL contains"
          value={settings.hideWhen}
          onChange={(value: string) => {
            onChange({
              hideWhen: value,
            })
          }}
        />
        <Input
          classes={{ root: styles.inputWidth }}
          label="Hide parameter value"
          value={settings.hideWhenValue}
          onChange={(value) => {
            onChange({
              hideWhenValue: value,
            })
          }}
        />
        <Tooltip
          horizontalStartPosition={TPopupHorizontal.Right}
          horizontalDirection={TPopupHorizontal.Left}
          tipContent={() => (
            <div>
              You can set a specific value or set any parameter values if you leave this field empty
            </div>
          )}
        >
          <Button variant={'text'} iconButton={'kbase kbase-info'} />
        </Tooltip>
      </div>
    </>
  )
}
